import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';

export class SyncDataState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;

  constructor() {
    this.isLoading = false;
    this.failures = null;
  }
}
